/* eslint max-len: 0 */
import Enum from 'enum';

export const Resources = new Enum({
  InitialAppUser: 'initial_app_user',
  ClientRoles: 'client_roles',
  ClientFacilities: 'clients/:clientId/facilities',
  ClientFacility: 'clients/:clientId/facilities/:facilityId',
  Clients: 'clients',
  ClientsOrphan: 'clients/orphan/:clientId',
  EmergencyBroadcast: 'emergency_broadcasts/:emergencyBroadcastId',
  EmergencyBroadcastApproval: 'emergency_broadcasts/:emergencyBroadcastId/approval',
  EmergencyBroadcastLimit: 'emergency_broadcasts/limits/:limitId',
  EmergencyBroadcasts: 'emergency_broadcasts',
  EmergencyMessage: 'emergency_messages/:emergencyBroadcastId',
  EmergencyMessages: 'emergency_messages',
  EmergencyMessageDecline: 'emergency_messages/:emergencyBroadcastId/decline',
  EmergencyMessagePending: 'emergency_messages/:emergencyBroadcastId/pending',
  Facilities: 'facilities',
  Facility: 'facilities/:facility_id',
  FacilityAddress: 'facilities/:facilityId/address',
  FacilityBillingContact: 'facilities/:facilityId/billing_contacts/:billingContactId',
  FacilityBillingContacts: 'facilities/:facilityId/billing_contacts',
  FacilityContractedProvider: 'facilities/:facility_id/contracted_providers/:contractedProviderId',
  FacilityContractedProviders: 'facilities/:facility_id/contracted_providers',
  FacilityContractedProviderUpdateSummary: 'facilities/:facility_id/contracted_providers/:contracted_provider_id/update_summary',
  FacilityCustomEasyAssign: 'facilities/:facility_id/custom-easy-assign',
  FacilityCancellationRecoveryConfig: 'facilities/:facility_id/cancellation-recovery',
  FacilityGainPermissionsContacts: 'facilities/:facilityId/gain_permissions_contacts',
  FacilityOrientedProviders: 'facilities/:facilityId/oriented-providers',
  FacilityOrientedProvidersTransfer: 'facilities/:facilityId/oriented-providers/transfer',
  FacilityPremiumRates: 'facilities/premium-rates',
  FavoritableProviders: 'favoritable-providers',
  InternalFacilityDocument: 'facilities/:facilityId/internal_documents/:documentId',
  InternalFacilityDocuments: 'facilities/:facilityId/internal_documents',
  Marketer: 'facilities/:facilityId/marketer',
  FacilityIntegration: 'facilities/:facilityId/integration',
  FacilityPeople: 'facilities/:facilityId/people',
  FacilityPPDReport: 'facilities/:facilityId/ppd_report',
  FacilityShiftDefinition: 'facilities/:facility_id/shift_definitions/:shiftDefinitionId',
  FacilityShiftDefinitions: 'facilities/:facility_id/shift_definitions',
  FacilityTeam: 'facilities/:facilityId/team/:teamId',
  FacilityTeamClients: 'facilities/:facilityId/team/:teamId/clients',
  FacilityTerms: 'facilities/:facilityId/terms',
  FacilityTypes: 'facility_types',
  FacilityFavoriteProvider: 'facility/:facilityId/favorite_provider/:providerId',
  FacilityFeatureFlag: 'facility_feature_flag/:id',
  FacilityFeatureFlagGlobal: 'facility_feature_flag/:id/global',
  Hospitals: 'hospitals',
  Hospital: 'hospitals/:hospital_id',
  SettingsIntegrations: 'settings/integrations',
  SettingsIntegration: 'settings/integrations/:integrationId',
  SettingsIntegrationConfigUrl: 'settings/integrations/:integrationId/config-url',
  OnShiftInitActivation: 'onshift/init-activation',
  OnShiftActivate: 'onshift/activate',
  OnShiftDeactivate: 'onshift/:facilityId/deactivate',
  PbjReport: 'pbj_report',
  ProviderBatchDnr: 'providers/:providerId/batch_dnr',
  ProviderDnr: 'providers/:providerId/dnrs/:dnrId',
  ProviderDnrs: 'providers/:providerId/dnrs',
  ProviderFlag: 'providers/:providerId/flags/:flagId',
  ProvidersFlags: 'providers/:providerId/flags',
  SystemSchedule: 'schedule',
  SystemScheduleDaysListWithShifts: 'schedule/days-list-with-shifts',
  SystemScheduleItem: 'schedule/:shift_opening_id',
  ShiftAssignmentResolution: 'shift_assignments/:shift_assignment_id/resolution',
  ShiftOpeningAvailableProviders: 'shift_openings/:shiftOpeningId/available_providers',
  Shift: 'shifts/:shiftId',
  ShiftInformation: 'shifts/:facilityId/information',
  ShiftsCount: 'shifts/count',
  ShiftsReportSummary: 'shifts_report_summary',
  ShiftsReport: 'shifts_report',
  TeamPermissionTypes: 'teams/permission_types',
  Team: 'teams/:teamId',
  Teams: 'teams',
  ProviderShiftRatings: 'providers/:providerId/shift_ratings',
  ProviderEndorsement: 'providers/:providerId/shift_endorsements/shift/:shiftId',
  ProviderEndorsementDefinitions: 'providers/shift_endorsements/definitions',
  ProfessionalAvailableShifts: 'professional-available-shifts/:providerId',
  ResendTeamAdministratorInvitation: 'teams/:teamId/administrator_invitations/:teamAdministratorInvitationId/resend',
  TeamAdministratorInvitation: 'teams/:teamId/administrator_invitations/:teamAdministratorInvitationId',
  TeamAdministratorInvitations: 'teams/:teamId/administrator_invitations',
  TeamAdministrator: 'teams/:teamId/administrators/:teamAdministratorId',
  TeamAdministrators: 'teams/:teamId/administrators',
  TeamFacility: 'teams/:teamId/facilities/:facilityId',
  TeamFacilities: 'teams/:teamId/facilities',
  TeamHospital: 'teams/:teamId/hospitals/:hospitalId',
  TeamHospitals: 'teams/:teamId/hospitals',
  TeamHospitalUnit: 'teams/:teamId/hospitals/:hospitalId/units/:unitId',
  TeamHospitalUnits: 'teams/:teamId/hospitals/:hospitalId/units',
  TeamHospitalUnitSpecialties: 'teams/:teamId/hospitals/:hospitalId/units/:unitId/specialties',
  TeamHospitalUnitSpecialty: 'teams/:teamId/hospitals/:hospitalId/units/:unitId/specialties/:facilityShiftDefinitionId',
  TeamInvitations: 'teams/invitations/:uuid',
  ResendTeamMemberInvitation: 'teams/:teamId/member_invitations/:teamMemberInvitationId/resend',
  TeamMemberInvitation: 'teams/:teamId/member_invitations/:teamMemberInvitationId',
  TeamMemberInvitations: 'teams/:teamId/member_invitations',
  TeamMemberFacility: 'teams/:teamId/members/:teamMemberId/facilities/:facilityId',
  TeamMemberFacilities: 'teams/:teamId/members/:teamMemberId/facilities',
  TeamMember: 'teams/:teamId/members/:teamMemberId',
  TeamMembers: 'teams/:teamId/members',
  TeamPersonFacility: 'teams/:teamId/people/:clientId/facilities/:facilityId',
  TeamPersonFacilities: 'teams/:teamId/people/:clientId/facilities',
  TeamPersonUnassignedFacilities: 'teams/:teamId/people/:clientId/unassigned-facilities',
  TeamPerson: 'teams/:teamId/people/:clientId',
  TeamPeople: 'teams/:teamId/people',
  UserShiftOpenings: 'user/shift_openings',
  OnShiftShiftProcessingStatus: 'onshift/:shiftId/shift_processing_status',

  // Non-API prefixed endpoints
  FacilityFeatureFlagExport: 'facility_feature_flag/:id/export',
  FacilityFeatureFlagImport: 'facility_feature_flag/:id/import',

  ProviderBioReport: 'providers/:providerId/bio-reports',
  ProviderBioReportReasons: 'bio-report-reasons',

  AvailableProvidersForBlockShift: 'facilities/:facilityId/block-shifts/available-providers',
});
